import { PROPAGATE_RECORDS_LIST_URL, PROPAGATION_JOB_SEARCH_URL, SCHEDULE_PROPAGATION_URL, RETRIEVE_PROPAGATION_LOGS_URL, REVERT_PROPAGATION_URL, RETRIGGER_PROPAGATION_URL } from "../../api";
import axiosInstance from "../../axiosInstance";

const getErrorMessage = (err) =>
    err?.response?.data?.message ||
    err?.response?.data?.detail ||
    err?.response?.data?.error ||
    err?.message ||
    "Something went wrong. Please try again.";

export const getPropagationRecordsListData = (props) => onResponse => {
    try {
        axiosInstance.get(PROPAGATE_RECORDS_LIST_URL, {
            params: {
                page: props?.page,
                limit: props?.limit,
                client: Array.isArray(props?.client) ? props.client.join(',') : props?.client || "",
                facility: Array.isArray(props?.facility) ? props.facility.join(',') : props?.facility || "",
                status: Array.isArray(props?.status) ? props.status.join(',') : props?.status || "",
                source_job: props?.source_job || "",
                propagate_job: props?.propagate_job || "",
                requested_user: Array.isArray(props?.requested_user) ? props.requested_user.join(',') : props?.requested_user || "",
                created_date_range: props?.created_date || "",
                sort_key: props?.sort_key || "",
                sort_order: props?.sort_order || "",
            }
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse({ status: false, message: getErrorMessage(err) });
            });
    } catch (error) {

    }
};

export const searchPropagationJob = (props) => onResponse => {
    try {
        axiosInstance.get(PROPAGATION_JOB_SEARCH_URL, {
            params: {
                client: props?.client || "",
                facility: props?.facility || "",
                unique: props?.unique || "",
                lockbox_name: props?.lockbox_name || "",
            }
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse({ status: false, message: getErrorMessage(err) });
            });
    } catch (error) {

    }
};

export const getPropagationLogs = (props) => onResponse => {
    try {
        axiosInstance.get(`${RETRIEVE_PROPAGATION_LOGS_URL}/${props?.id}`)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse({ status: false, message: getErrorMessage(err) });
            });
    } catch (error) {

    }
};

export const revertPropagation = (props) => onResponse => {
    try {
        axiosInstance.post(`${REVERT_PROPAGATION_URL}/${props?.id}`, {
            remarks: props?.remarks || "",
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse({ status: false, message: getErrorMessage(err) });
            });
    } catch (error) {

    }
};

export const retriggerPropagation = (props) => onResponse => {
    try {
        axiosInstance.post(`${RETRIGGER_PROPAGATION_URL}/${props?.id}`, {
            remarks: props?.remarks || "",
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse({ status: false, message: getErrorMessage(err) });
            });
    } catch (error) {

    }
};

export const schedulePropagation = (props) => onResponse => {
    try {
        axiosInstance.post(SCHEDULE_PROPAGATION_URL, {
            client: props?.client,
            facility: props?.facility,
            source_job: props?.source_job,
            propagate_job: props?.propagate_job,
            remarks: props?.remarks || "",
            target_job_status: props?.target_job_status || null,
            include_snipping_payload: !!props?.include_snipping_payload,
        })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse({ status: false, message: getErrorMessage(err) });
            });
    } catch (error) {

    }
};
